import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MyaccountPermissionsComponent } from './myaccount-permissions.component';

@NgModule({
  declarations: [MyaccountPermissionsComponent],
  exports: [MyaccountPermissionsComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    I18nModule,
    MatCheckboxModule,
    ConfigModule.withConfig({
      cmsComponents: {
        EditEmployeeComponent: {
          component: MyaccountPermissionsComponent,
          // deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class MyaccountPermissionsModule {}
